export default "__VITE_ASSET__BJZQQT8X__"